import React, { useState, useEffect } from "react";
import { selectFlow, setEditorSaved } from "../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";
import { mergeCurrentActionToFlow } from "../../../../../../common/utils/integration.util";
import { clone } from "../../../../../../common/utils/helper";
import uuid from "react-uuid";
import CombinedConditionPanel from "./types/CombinedConditionPanel";
import CombinedConditionControl from "./controlbar/CombinedConditionControl";
import { Label } from "@atlaskit/form";
import ShowFullScopeVariablePathHint from "../../extension/ShowFullScopeVariablePathHint";
import TopUsedConditions from "./TopUsedConditions";
const ConditionsPage = ({ action, flow }) => {
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (action && action.conditions) {
      setRows(renderCombinedConditions());
    } else {
      setRows([]);
    }
  }, [action]);
  const onAddCombinedCondition = (combinedConditions) => {
    action.conditions = combinedConditions;
    setRows(renderCombinedConditions());
    const mergedFLow = mergeCurrentActionToFlow(action, flow);
    dispatch(selectFlow(mergedFLow));
  };
  const onModifyCondition = (conditions, index) => {
    const clonedAction = clone(action);
    setRows(renderCombinedConditions());
    const mergedFLow = mergeCurrentActionToFlow(clonedAction, flow);
    dispatch(selectFlow(mergedFLow));
    dispatch(setEditorSaved(false));
  };

  const removeByIndex = (arr, index) => (index >= 0 && index < arr.length ? [...arr.slice(0, index), ...arr.slice(index + 1)] : [...arr]); // Return a copy if the index is out of bounds

  const removeCombinedCondition = (index) => {
    const clonedAction = clone(action);
    clonedAction.conditions = removeByIndex(clonedAction.conditions, index);
    const mergedFLow = mergeCurrentActionToFlow(clonedAction, flow);
    dispatch(selectFlow(mergedFLow));
    dispatch(setEditorSaved(false));
    setRows(renderCombinedConditions());
  };

  const renderCombinedConditions = () => {
    if (!action) {
      return "";
    }
    return action.conditions.map((cc, index) => {
      return (
        <CombinedConditionPanel
          combinedCondition={cc}
          key={uuid()}
          index={index}
          addCondition={onModifyCondition}
          removeCombinedCondition={removeCombinedCondition}
        />
      );
    });
  };

  const title = action && action.conditions && action.conditions.length > 0 ? "+ OR" : "ADD";
  return (
    <>
      <p className="ihub-action-tab-description">
        Choose when you want this action to run based on certain situations. This can be based on what happened before or the result of a previous
        step. You can mix conditions using "AND" (all conditions must be met) or "OR" (any condition is enough).
      </p>
      <ShowFullScopeVariablePathHint />
      <TopUsedConditions/>
      <br />
      {rows.length > 0 && <center>Only run this action if...</center>}
      {rows}
      <hr />
      <Label>Add new condition</Label>
      <CombinedConditionControl conditions={action && action.conditions} title={title} addCombinedCondition={onAddCombinedCondition} />
    </>
  );
};

export default ConditionsPage;
